var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 2C13.0335 2.00008 13.3474 2.13057 13.6084 2.3916C13.8694 2.65264 13.9999 2.96648 14 3.33301V12.667C13.9999 13.0335 13.8694 13.3474 13.6084 13.6084C13.3474 13.8694 13.0335 13.9999 12.667 14H3.33301C2.96648 13.9999 2.65264 13.8694 2.3916 13.6084C2.13057 13.3474 2.00008 13.0335 2 12.667V3.33301C2.00008 2.96648 2.13057 2.65264 2.3916 2.3916C2.65264 2.13057 2.96648 2.00008 3.33301 2H12.667ZM3.33301 12.667H12.667V3.33301H3.33301V12.667ZM11.2002 10.5C11.4763 10.5 11.7002 10.7239 11.7002 11C11.7002 11.2761 11.4763 11.5 11.2002 11.5H8.2002C7.92405 11.5 7.7002 11.2761 7.7002 11C7.7002 10.7239 7.92405 10.5 8.2002 10.5H11.2002ZM4.58398 5.42285C4.73716 5.19309 5.04758 5.131 5.27734 5.28418L8.05469 7.13574C8.44373 7.39538 8.47362 7.95639 8.11426 8.25586L5.32031 10.584C5.10831 10.7606 4.79303 10.7323 4.61621 10.5205C4.43953 10.3085 4.46789 9.99325 4.67969 9.81641L7.16504 7.74414L4.72266 6.11621C4.49293 5.96306 4.43092 5.6526 4.58398 5.42285Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPrompt);
export default __webpack_public_path__ + "static/media/icons-prompt.973e4876.svg";
export { ForwardRef as ReactComponent };